var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessCircleOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path451",
    d: "M0-682.665H21v21H0Z",
    transform: "translate(0 682.665)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_41313",
    "data-name": "Group 41313",
    transform: "translate(21025 2669)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15675",
    "data-name": "Rectangle 15675",
    width: 24,
    height: 24,
    transform: "translate(-21025 -2669)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "check-mark",
    transform: "translate(-21023.5 -2667.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g441"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g443",
    transform: "translate(6.438 7.748)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path445",
    d: "M-255.939,0l-5.5,5.5-2.62-2.62",
    transform: "translate(264.062)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g447"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g449",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g455",
    transform: "translate(0.82 0.82)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path457",
    d: "M-609.972-304.986a9.68,9.68,0,0,1-9.68,9.68,9.68,9.68,0,0,1-9.68-9.68,9.68,9.68,0,0,1,9.68-9.68A9.68,9.68,0,0,1-609.972-304.986Z",
    transform: "translate(629.332 314.666)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessCircleOutlined);
export default __webpack_public_path__ + "static/media/success-circle-outlined.cbf17163f1a9497a5ce9e9fc7149dac8.svg";
export { ForwardRef as ReactComponent };